import { devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';
import { createSafeJSONStorage } from '../../helpers/storage/persist-storage';
import { isLoggingEnabled, logger } from '../logger/logger';
import { SignInStep, SignUpStep } from './auth-store.type';
import type { State } from './auth-store.type';

const initialState: State = {
  signUpInitialized: false,
  signUpStep: SignUpStep.CreateAccount,
  signInStep: SignInStep.Login,
  email: null,
  password: null,
  organizationName: null,
};

const useAuthStore = create<State>()(
  devtools(
    persist(
      logger((_) => ({
        ...initialState,
      })),
      {
        name: 'auth-storage',
        storage: createSafeJSONStorage(() => sessionStorage),
        partialize: (state) =>
          Object.fromEntries(Object.entries(state).filter(([key]) => !['password', 'signUpInitialized'].includes(key))),
      },
    ),
    {
      name: 'Bloomfilter - Auth Store',
      enabled: isLoggingEnabled,
    },
  ),
);

export { initialState, useAuthStore };
